<template>
  <v-card>
    <v-toolbar color="primary" flat>
      <v-toolbar-title>Uhive</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
        class="mr-6"
        dark
        target="_blank"
        href="https://wiki.uhive.com/kb/import-accounts/"
      >Help?</v-btn>
      <v-btn v-if="$store.state.auth.authenticated" @click="logout">Logout</v-btn>
      <v-btn v-else :href="url">Sign in</v-btn>

      <template v-slot:extension>
        <v-tabs
          style="width:70%"
          v-if="$store.state.auth.authenticated"
          color="secondary"
          align-with-title
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab class="caption" to="/import">Import Facebook and Instagram profile</v-tab>
        </v-tabs>

        <p v-if="$store.state.auth.authenticated" class="font-weight-medium body-2">
          You are signed in as:
          <strong>{{$store.state.user.info.email || $store.state.user.info.phone_number}}</strong>
        </p>
      </template>
    </v-toolbar>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      url: process.env.VUE_APP_UHIVE_MAIN_SITE + "web/login/",
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout") &&
        this.$router.push({ name: "login" });
    }
  }
};
</script>

<style scoped>
</style>